
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { CustomerMeterDetails, Store, } from '~/apps/account/store';
import IconButton from '~/components/icon-button/icon-button.vue';
import { OutsideClick, } from '~/directives/outside-click';
import type { Result, } from '~/utils/models/result';
import type { CustomerBasicDetails, } from '~/utils/models/userDetails';
import type { GlobalConfig, } from '~/utils/self-serve/global-config';
import AccountNavLinks from '../account-nav-links/account-nav-links.vue';

@Component({
	components: {
		IconButton,
		AccountNavLinks,
	},
	directives: {
		OutsideClick,
	},
})
export default class AccountNav extends Vue {
	isMobileMenuExpended = false;
	homePageLocation = Store.getters.getGlobalConfigValue('HomePageLocation') || '/';

	@Prop({
		required: true,
	})
	currentUser!: CustomerBasicDetails;

	@Prop({
		type: String,
		required: true,
	})
	logo!: string;

	@Prop({
		type: [ Number, String, ],
		required: false,
	})
	logoWidth: number | string | undefined;

	@Prop({
		type: [ Number, String, ],
		required: false,
	})
	logoHeight: number | string | undefined;

	@Prop({
		type: Object,
		required: false,
	})
	logoDetails: GlobalConfig['SouthernWaterLogoDetails'];

	@Prop({
		type: String,
		required: false,
	})
	moveOutDate!: string | null;

	@Prop({
		required: true,
	})
	meterDetail!: Result<CustomerMeterDetails[]>;

	@Prop({
		type: Array,
		required: false,
		default: () => [],
	})
	customerPropertyDetailList!: [];

	@Prop({
		type: String,
		required: false,
	})
	paymentMethod!: string | null;

	@Prop({ default: 'content', })
		contentAchor!: string;

	toggleMobileMenu() {
		this.isMobileMenuExpended = !this.isMobileMenuExpended;
	}

	mounted() {
		this.$router?.afterEach(() => {
			this.isMobileMenuExpended = false;
		});
	}

	handleOpenMobileNavMenu() {
		if (this.isMobileMenuExpended === true) {
			this.isMobileMenuExpended = false;
		}
	}

	handleViewProfileClick() {
		localStorage.removeItem('activeTab');
	}

}
